module.exports = __webpack_public_path__ + "img/42618722b98273d79df2154616b7fc6e.png";